import {
  ReactivationPrefillResult,
  ReactivationPrefillResultTypenames,
} from '@varo/graphql-schema-types';
import { useEffect, useState } from 'react';
import GetReactivationPrefillData from 'services/graphql/queries/reactivation/GetReactivationPrefillData';
import { AnyVariables, RequestPolicy, useQuery } from 'urql';

const useReactivationPrefillData = ({
  requestPolicy = 'cache-and-network',
}: {
  requestPolicy?: RequestPolicy;
} = {}) => {
  const [{ data, fetching, error }, refetch] = useQuery<
    {
      getReactivationPrefillData: ReactivationPrefillResult;
    },
    AnyVariables
  >({
    query: GetReactivationPrefillData,
    requestPolicy: requestPolicy,
  });

  const [reactivationApplicationId, setReactivationApplicationId] =
    useState<string>('');

  useEffect(() => {
    if (
      data?.getReactivationPrefillData.__typename ===
      ReactivationPrefillResultTypenames.ReactivationPrefillSuccess
    ) {
      setReactivationApplicationId(
        data.getReactivationPrefillData.registrationInfoId,
      );
    }
  }, [data]);

  const prefillData =
    data?.getReactivationPrefillData.__typename ===
    ReactivationPrefillResultTypenames.ReactivationPrefillSuccess
      ? data.getReactivationPrefillData
      : null;

  const prefillDataError =
    error ||
    (data?.getReactivationPrefillData.__typename ===
    ReactivationPrefillResultTypenames.ReactivationPrefillError
      ? data.getReactivationPrefillData
      : null);

  return {
    prefillData,
    prefillDataFetching: fetching,
    prefillDataError,
    refetch,
    reactivationApplicationId,
  };
};

export default useReactivationPrefillData;
